import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "manage-order content" }
const _hoisted_2 = {
  class: "",
  style: {"color":"#000"}
}
const _hoisted_3 = {
  key: 3,
  class: "item"
}
const _hoisted_4 = { class: "t-header flex-row flex-justify-sb" }
const _hoisted_5 = { class: "t-date" }
const _hoisted_6 = { class: "t-body flex-row" }
const _hoisted_7 = { class: "pickup flex-col" }
const _hoisted_8 = { class: "return flex-col" }
const _hoisted_9 = {
  key: 0,
  class: "t-instructions"
}
const _hoisted_10 = { class: "title" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "left" }
const _hoisted_13 = { class: "activity-title" }
const _hoisted_14 = {
  key: 0,
  class: "activity-time"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = {
  key: 1,
  class: "activity-time red"
}
const _hoisted_17 = { class: "item-box col" }
const _hoisted_18 = { class: "flex spaced v-center" }
const _hoisted_19 = { class: "activity-title" }
const _hoisted_20 = { class: "bal" }
const _hoisted_21 = {
  key: 0,
  class: "gg-chevron-right"
}
const _hoisted_22 = {
  key: 5,
  class: "item"
}
const _hoisted_23 = { class: "item-box center" }
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 6,
  class: "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notify_box = _resolveComponent("notify-box")!
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.paid)
      ? (_openBlock(), _createBlock(_component_notify_box, {
          key: 0,
          type: "success"
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createTextVNode(" Your order was successfully paid ", -1)
          ])),
          _: 1,
          __: [1]
        }))
      : _createCommentVNode("", true),
    (_ctx.cancelled)
      ? (_openBlock(), _createBlock(_component_notify_box, {
          key: 1,
          type: "success"
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode(" Your order was successfully cancelled ", -1)
          ])),
          _: 1,
          __: [2]
        }))
      : _createCommentVNode("", true),
    (_ctx.success)
      ? (_openBlock(), _createBlock(_component_notify_box, {
          key: 2,
          type: "success"
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode(" Your order was successfully updated ", -1)
          ])),
          _: 1,
          __: [3]
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.customerName) + " • Order #" + _toDisplayString(_ctx.order?.orderNumber ?? ' N/A'), 1),
    (_ctx.transportationMapping?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "title" }, "Transportation", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transportationMapping, (t) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "transportation item-box flex-col",
              key: t.date
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(t.date), 1),
                  _cache[4] || (_cache[4] = _createTextVNode(" • ", -1)),
                  _createElementVNode("span", null, _toDisplayString(t.guests), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createElementVNode("div", { class: "gray" }, "Pickup", -1)),
                  _createElementVNode("div", null, _toDisplayString(t.pickup.time), 1),
                  _createElementVNode("div", null, _toDisplayString(t.pickup.place), 1)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "gray" }, "Return", -1)),
                  _createElementVNode("div", null, _toDisplayString(t.return.time), 1),
                  _createElementVNode("div", null, _toDisplayString(t.return.place), 1)
                ])
              ]),
              (t.instructions)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "flex-row flex-justify-sb" }, [
                      _createElementVNode("span", { class: "gray" }, "Pickup instructions")
                    ], -1)),
                    _createElementVNode("div", null, _toDisplayString(t.instructions), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityStatuses, ([status, times]) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: status
      }, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(status), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(times, (time) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item-box row link v-center anim", status]),
            key: time.OrderEntityTimeKey ?? -1,
            onClick: ($event: any) => (_ctx.linkTo(time))
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(time.Appointment.ActivityName), 1),
              (time.AppointmentTypeKey != 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createTextVNode(_toDisplayString(time.AppointmentDate), 1),
                    (time.AppointmentTypeKey == 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, " @ " + _toDisplayString(time.TimeString), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (time.arrivalTime)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "** Please arrive by " + _toDisplayString(time.arrivalTime), 1))
                : _createCommentVNode("", true)
            ]),
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "right" }, [
              _createElementVNode("div", { class: "gg-chevron-right" })
            ], -1))
          ], 10, _hoisted_11))
        }), 128))
      ]))
    }), 128)),
    (_ctx.balance)
      ? (_openBlock(), _createElementBlock("div", {
          key: 4,
          class: _normalizeClass(["item anim", { clickable: _ctx.balance > 0 }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.linkToPayment()))
        }, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "title" }, "Order Details", -1)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.balance > 0 ? 'Pay ' : '') + "Order Balance:", 1),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("span", {
                  class: _normalizeClass(_ctx.balanceClass)
                }, [
                  _createVNode(_component_si_currency, {
                    amount: Math.abs(_ctx.balance)
                  }, null, 8, ["amount"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.type), 1)
                ], 2),
                (_ctx.balance > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.ticketUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _cache[11] || (_cache[11] = _createElementVNode("div", { class: "title" }, "Digital Ticket", -1)),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("img", {
              src: _ctx.ticketUrl,
              width: "250"
            }, null, 8, _hoisted_24)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_router_view, { class: "modal-content" })
        ]))
      : _createCommentVNode("", true)
  ]))
}